import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Slider from '@mui/material/Slider';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

function FloatingPanel({rendererRef}) {
  const [checked, setChecked] = useState({ inflate: false, skirt: true });
  const [weight, setWeight] = useState(0);
  const [chest, setChest] = useState(0);
  const [progress, setProgress] = useState(50);
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setInterval(()=>{
        setProgress(rendererRef.current.progress);
    }, 1000)

    const handleResize = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleCheckboxChange = (event) => {
    setChecked({ ...checked, [event.target.name]: event.target.checked });

    if (event.target.name == 'skirt'){
        rendererRef.current.toggleSkirt(event.target.checked);
    }else{
        rendererRef.current.toggleTube(event.target.checked);
    }
  };

  const handleSliderChange = (event, newValue) => {
    setWeight(newValue);
    //console.log(newValue);
    rendererRef.current.setWeight(newValue/100);
  };

  const handleSliderChest = (event, newValue) => {
    setChest(newValue);
    //console.log(newValue);
    rendererRef.current.setChest(newValue/100);
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const handleDeflate = () =>{
    if (rendererRef.current.progress > 0){
        rendererRef.current.deflate(0.1);
        setProgress(progress-10);
        //console.log(Math.max(rendererRef.current.progress -10, 0)/100)
    }
  }

  return (
    <>
        <Box sx={{
          position: 'fixed',
          bottom: true ? 'auto' : 16,
          left: true ? 'auto' : 16,
          transform: true ? 'translateY(-50%)' : 'translateX(-50%)',
          top: true ? '50%' : 'auto',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          boxShadow: 3,
          borderRadius: 1,
          minHeight:'50px',
          
        }}>
            <Button
                onClick={toggleVisibility}
                fullWidth
                variant="outlined"
            >
                {isVisible ? '<' : '>'}
            </Button>
            {isVisible && (<div style={{display: 'flex',
            padding:'20px',
          flexDirection: 'column',
          alignItems: 'left',
          gap: 1}}>
            <LinearProgress variant="determinate" value={progress} />
          <FormControlLabel 
            control={
              <Checkbox checked={checked.inflate} onChange={handleCheckboxChange} name="inflate" />
            }
            label="Inflate"
          />
          <FormControlLabel
            control={
              <Checkbox checked={checked.skirt} onChange={handleCheckboxChange} name="skirt" />
            }
            label="Skirt"
          />
          <Button onClick={handleDeflate}>Deflate</Button>
          <Typography id="input-slider" gutterBottom>
            Weight
          </Typography>
          <Slider

            value={weight}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            min={0}
            max={100}
          />

            <Typography id="input-slider" gutterBottom>
            Chest
          </Typography>
          <Slider

            value={chest}
            onChange={handleSliderChest}
            aria-labelledby="input-slider"
            min={0}
            max={100}
          />
          
          </div>)}
        </Box>
        
      
    </>
  );
}

export default FloatingPanel;
